import { ReactComponent as BrandLogoRed } from 'assets/icons/brandLogo-red.svg';
import styled from 'styled-components';

export const Logo = styled(BrandLogoRed).attrs({ className: 'header-logo' })`
  .a {
    fill: ${({ theme }) => theme.colors.primary.lightMobile};
  }
`;
